import React from 'react'

const Sidebar = () => {
    let data = [1, 2, 3, 4, 5, 6]
    return (
        <>
            <div className="col-sm-12 col-xxl-4">
                {/* <div className="blog_details_search_section">
                    <h3>Search</h3>
                    <input type="text" placeholder='Search' />
                </div> */}
                <div className="blog_details_categories_section">
                    <h3>Categories</h3>
                    <ul>
                        <li>Property</li>
                        <li>Villa</li>
                        <li>House</li>
                        <li>Guest House</li>
                        <li>Factory</li>
                    </ul>
                </div>

                <div className="blog_details_top_article_section">
                    <h3>Top Articles</h3>
                    {
                        data?.map((item, i) => {
                            return <div key={i} className="d-flex align-items-center my-3">
                                <img src="/images/image1.jpg" alt="image" />
                                <h4>Excited News About
                                    Buildings</h4>
                            </div>
                        })
                    }

                </div>
            </div>
        </>
    )
}

export default Sidebar